(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pedido-personalizado"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   Asistente de cotización — una pregunta por pantalla, sin recargar.
   El estado vive en memoria y al enviar se arma un POST a /contact.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Íconos ----------
     Antes cada opción traía un emoji. Cada emoji viene con su propia paleta y
     su propio nivel de detalle — el posavasos era un vaso con un trago
     adentro, "mi logo" una paleta de pintor — así que una pantalla con seis
     opciones eran seis dibujos peleando entre sí y ninguno decía lo que la
     opción significa.

     Ahora son trazos: mismo grosor, mismo tamaño, el color lo pone el tema.
     Se dibujan una vez acá y se reutilizan; donde antes había 84 emoji
     distintos hay un set de conceptos, y los tamaños y las cantidades se
     entienden solos porque el círculo crece y los puntos se multiplican. */
  function ico(d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }
  var ICO = {
    /* productos */
    disco:    ico('<circle cx="12" cy="12" r="8.4"/><circle cx="12" cy="12" r="3.2"/>'),
    llave:    ico('<circle cx="8.6" cy="8.6" r="4.1"/><path d="m11.6 11.6 7.6 7.6M17 19.4l2-2M14.6 17l1.8-1.8"/>'),
    soporte:  ico('<rect x="6.2" y="2.8" width="11.6" height="18.4" rx="2.4"/><path d="M10.2 18.2h3.6"/>'),
    medalla:  ico('<circle cx="12" cy="14.6" r="5.9"/><path d="M8.6 3.1l2.1 5.7M15.4 3.1l-2.1 5.7"/>'),
    placa:    ico('<rect x="3.2" y="4.6" width="17.6" height="10.8" rx="2.2"/><path d="M12 15.4v4.2M8.6 19.6h6.8"/>'),
    pieza:    ico('<path d="M12 2.9 20.6 7.6v8.8L12 21.1 3.4 16.4V7.6z"/><path d="m3.4 7.6 8.6 4.7 8.6-4.7M12 12.3v8.8"/>'),
    /* qué lleva impreso */
    etiqueta: ico('<path d="M11.4 3.2H20a.8.8 0 0 1 .8.8v8.6a2 2 0 0 1-.6 1.4l-6.4 6.4a1.4 1.4 0 0 1-2 0l-7-7a1.4 1.4 0 0 1 0-2l6.2-6.2a2 2 0 0 1 1.4-.6z"/><circle cx="16.4" cy="7.6" r="1.3"/>'),
    frase:    ico('<path d="M20.4 12.6a7.4 7.4 0 0 1-8 7.4l-5.6 1.4 1.4-4.2a7.4 7.4 0 1 1 12.2-4.6z"/>'),
    imagen:   ico('<rect x="3.2" y="4.6" width="17.6" height="14.8" rx="2.4"/><circle cx="8.6" cy="9.8" r="1.6"/><path d="m3.6 17.4 5-4.6 4.4 4 3-2.4 4.4 3.6"/>'),
    magia:    ico('<path d="M12 3v3.4M12 17.6V21M4.6 12H8M16 12h3.4M6.8 6.8l2.4 2.4M14.8 14.8l2.4 2.4M17.2 6.8l-2.4 2.4M9.2 14.8l-2.4 2.4"/>'),
    letras:   ico('<path d="M4.4 18.4 9.6 5.6l5.2 12.8M6.2 14.2h6.8M17.4 18.4V9.6M17.4 12.4c1.2-1.6 3.4-1.4 3.4.8v5.2"/>'),
    figura:   ico('<circle cx="12" cy="6.4" r="3"/><path d="M6.4 20.8c0-3.6 2.5-6 5.6-6s5.6 2.4 5.6 6"/>'),
    lista:    ico('<path d="M9.4 6.4h11M9.4 12h11M9.4 17.6h11M4.4 6.4h.1M4.4 12h.1M4.4 17.6h.1"/>'),
    personas: ico('<circle cx="9" cy="7.6" r="3.2"/><path d="M3.4 20c0-3.4 2.4-5.8 5.6-5.8s5.6 2.4 5.6 5.8"/><path d="M16.4 5.2a3.2 3.2 0 0 1 0 6.2M18 14.6c1.8.8 3 2.7 3 5.4"/>'),
    puzzle:   ico('<path d="M9.6 3.4h4.8v2.4a1.8 1.8 0 1 0 3.6 0V3.4h2.6v17.2H4.4v-6.2h2.4a1.8 1.8 0 1 0 0-3.6H4.4V3.4h5.2z"/>'),
    modelar:  ico('<path d="M4.6 15.4 15.8 4.2a2.4 2.4 0 0 1 3.4 3.4L8 18.8l-4.2 1z"/><path d="m14 6 4 4"/>'),
    /* destinos del QR */
    camara:   ico('<rect x="3" y="6.4" width="18" height="13.2" rx="2.6"/><circle cx="12" cy="13" r="3.6"/><path d="M8.4 6.4 9.8 3.8h4.4l1.4 2.6"/>'),
    web:      ico('<circle cx="12" cy="12" r="8.8"/><path d="M3.2 12h17.6M12 3.2c2.2 2.4 3.4 5.5 3.4 8.8s-1.2 6.4-3.4 8.8c-2.2-2.4-3.4-5.5-3.4-8.8S9.8 5.6 12 3.2z"/>'),
    menu:     ico('<path d="M5.4 3.4v7a2.6 2.6 0 0 0 5.2 0v-7M8 10.4v10.2"/><path d="M17.4 3.4c-1.6 1.6-2.2 3.6-2.2 6s.6 3.4 2.2 3.4h1.6V3.4z"/><path d="M18.2 12.8v7.8"/>'),
    pago:     ico('<rect x="2.6" y="5.4" width="18.8" height="13.2" rx="2.4"/><path d="M2.6 10h18.8M6.4 14.6h3.4"/>'),
    enlace:   ico('<path d="M10.2 13.8a3.6 3.6 0 0 0 5.4.4l2.8-2.8a3.6 3.6 0 0 0-5.1-5.1l-1.6 1.6"/><path d="M13.8 10.2a3.6 3.6 0 0 0-5.4-.4l-2.8 2.8a3.6 3.6 0 0 0 5.1 5.1l1.6-1.6"/>'),
    /* dónde va */
    mostrador:ico('<path d="M3.4 9.4h17.2l-1 10.2a1.6 1.6 0 0 1-1.6 1.4H6a1.6 1.6 0 0 1-1.6-1.4z"/><path d="M7.6 9.4V6.6a4.4 4.4 0 0 1 8.8 0v2.8"/>'),
    mesa:     ico('<path d="M3.4 9.6h17.2M5.4 9.6v10.8M18.6 9.6v10.8M12 9.6V4.2"/><path d="M7.4 4.2h9.2"/>'),
    feria:    ico('<path d="m12 3.4 9 9.4H3z"/><path d="M3 12.8v7.8h18v-7.8M12 20.6v-5.4"/>'),
    camion:   ico('<path d="M2.6 6.4h10.8v10.2H2.6z"/><path d="M13.4 10.2h3.8l3.2 3.4v3h-7z"/><circle cx="7" cy="18.6" r="2"/><circle cx="17" cy="18.6" r="2"/>'),
    pared:    ico('<rect x="3" y="4.6" width="18" height="14.8" rx="1.6"/><path d="M3 9.6h18M3 14.6h18M8.6 4.6v5M15.4 9.6v5M8.6 14.6v4.8"/>'),
    vitrina:  ico('<rect x="3.4" y="3.4" width="17.2" height="17.2" rx="2"/><path d="M12 3.4v17.2M3.4 12h17.2"/>'),
    empresa:  ico('<path d="M4.4 20.6V5a1.6 1.6 0 0 1 1.6-1.6h7.2A1.6 1.6 0 0 1 14.8 5v15.6"/><path d="M14.8 9.6h3.2a1.6 1.6 0 0 1 1.6 1.6v9.4M2.6 20.6h18.8"/><path d="M8 7.6h3M8 11.6h3M8 15.6h3"/>'),
    fabrica:  ico('<path d="M3 20.6V10l6 3.6V10l6 3.6V6.4h6v14.2z"/><path d="M2.6 20.6h18.8"/>'),
    /* decisiones */
    duda:     ico('<circle cx="12" cy="12" r="8.8"/><path d="M9.6 9.6a2.5 2.5 0 0 1 4.9.8c0 1.7-2.5 2.5-2.5 2.5M12 16.6v.1"/>'),
    listo:    ico('<circle cx="12" cy="12" r="8.8"/><path d="m8.2 12.2 2.6 2.6 5-5.6"/>'),
    lupa:     ico('<circle cx="10.8" cy="10.8" r="6.6"/><path d="m15.6 15.6 4.8 4.8"/>'),
    solo:     ico('<circle cx="12" cy="12" r="8.8"/>'),
    /* eventos */
    balon:    ico('<circle cx="12" cy="12" r="8.8"/><path d="m12 6.6 4 2.9-1.5 4.7h-5L8 9.5z"/><path d="M12 3.2v3.4M4.4 9.4 8 9.5M19.6 9.4 16 9.5M7.4 20l2.1-3.8M16.6 20l-2.1-3.8"/>'),
    colegio:  ico('<path d="m12 4-9.4 4.4L12 12.8l9.4-4.4z"/><path d="M6.4 10.6v5.2c0 1.8 2.5 3.2 5.6 3.2s5.6-1.4 5.6-3.2v-5.2"/>'),
    gimnasio: ico('<path d="M4.4 9.4v5.2M7.4 7.4v9.2M16.6 7.4v9.2M19.6 9.4v5.2M7.4 12h9.2"/>'),
    cumple:   ico('<path d="M4.4 20.6V13a2 2 0 0 1 2-2h11.2a2 2 0 0 1 2 2v7.6z"/><path d="M2.6 20.6h18.8M12 11V7.4"/><path d="M12 3.4c.9.8 1.3 1.5 1.3 2.1a1.3 1.3 0 0 1-2.6 0c0-.6.4-1.3 1.3-2.1z"/>'),
    trofeo:   ico('<path d="M8 4.4h8v5a4 4 0 0 1-8 0z"/><path d="M8 6.4H5.4a2.6 2.6 0 0 0 2.6 4M16 6.4h2.6a2.6 2.6 0 0 1-2.6 4M12 13.4v3.2M8.6 20.6h6.8l-.8-4H9.4z"/>'),
    podio:    ico('<path d="M9.2 20.6V9.4h5.6v11.2M3.4 20.6v-6.8h5.8M14.8 20.6v-8.8h5.8v8.8"/><path d="M2.6 20.6h18.8"/>'),
    cinta:    ico('<circle cx="12" cy="8.6" r="5.2"/><path d="m8.8 13 -2 7.6 5.2-3 5.2 3-2-7.6"/>'),
    repuesto: ico('<circle cx="12" cy="12" r="3"/><path d="M19.2 14.6a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1v.3a2 2 0 1 1-4 0v-.2a1.6 1.6 0 0 0-2.8-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0-1.1-2.7H3a2 2 0 1 1 0-4h.2a1.6 1.6 0 0 0 1.1-2.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 2.7-1.1V3a2 2 0 1 1 4 0v.2a1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7h.3a2 2 0 1 1 0 4h-.2a1.6 1.6 0 0 0-1.4 1z"/>'),
    caja:     ico('<path d="M20.6 8.4v7.2a1.8 1.8 0 0 1-.9 1.5l-6.8 3.8a1.8 1.8 0 0 1-1.8 0l-6.8-3.8a1.8 1.8 0 0 1-.9-1.5V8.4a1.8 1.8 0 0 1 .9-1.5l6.8-3.8a1.8 1.8 0 0 1 1.8 0l6.8 3.8a1.8 1.8 0 0 1 .9 1.5z"/><path d="m3.6 7.6 8.4 4.6 8.4-4.6M12 20.8v-8.6"/>'),
    /* tamaños: el círculo crece con la talla */
    tamS:     ico('<circle cx="12" cy="12" r="3.4"/>'),
    tamM:     ico('<circle cx="12" cy="12" r="6"/>'),
    tamL:     ico('<circle cx="12" cy="12" r="8.6"/>'),
    regla:    ico('<path d="M3.4 15.4 15.4 3.4l5.2 5.2-12 12z"/><path d="m7 11.8 1.8 1.8M10 8.8l1.8 1.8M13 5.8l1.8 1.8"/>'),
    /* cantidades: los puntos se multiplican */
    cant1:    ico('<circle cx="12" cy="12" r="2.6"/>'),
    cant3:    ico('<circle cx="8" cy="9.4" r="2.2"/><circle cx="16" cy="9.4" r="2.2"/><circle cx="12" cy="16" r="2.2"/>'),
    cant6:    ico('<circle cx="7.4" cy="8" r="1.9"/><circle cx="12" cy="8" r="1.9"/><circle cx="16.6" cy="8" r="1.9"/><circle cx="7.4" cy="15.4" r="1.9"/><circle cx="12" cy="15.4" r="1.9"/><circle cx="16.6" cy="15.4" r="1.9"/>'),
    cantN:    ico('<circle cx="6.4" cy="6.6" r="1.5"/><circle cx="12" cy="6.6" r="1.5"/><circle cx="17.6" cy="6.6" r="1.5"/><circle cx="6.4" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="17.6" cy="12" r="1.5"/><circle cx="6.4" cy="17.4" r="1.5"/><circle cx="12" cy="17.4" r="1.5"/><circle cx="17.6" cy="17.4" r="1.5"/>'),
    /* plazos */
    hoja:     ico('<path d="M4.6 19.4C3 15.8 4 9 9.4 6.2c3.4-1.8 7.4-1.4 10.6-2.4.6 4.4-.4 12.8-6.4 15.2-3.4 1.4-6.6.8-9-.4z"/><path d="M4.6 19.4c1.6-4.6 5-8.6 9.4-10.8"/>'),
    reloj:    ico('<circle cx="12" cy="12" r="8.8"/><path d="M12 6.8V12l3.4 2"/>'),
    rayo:     ico('<path d="M13.4 2.6 4.6 13.4h6.4l-1.4 8 8.8-10.8h-6.4z"/>')
  };

  /* ---------- Productos predeterminados ---------- */
  var PRESETS = {
    posavasos: {
      nombre: 'Posavasos personalizados', ico: ICO.disco, sub: 'Con tu logo o tu frase',
      minimo: 10, pasos: ['posa_que', 'posa_tamano', 'cantidad', 'colores']
    },
    llaveros: {
      nombre: 'Llaveros personalizados', ico: ICO.llave, sub: 'Nombres, logos o figuras',
      minimo: 10, pasos: ['lla_que', 'lla_tamano', 'cantidad', 'lla_iguales', 'colores']
    },
    qr: {
      nombre: 'Soporte con código QR', ico: ICO.soporte, sub: 'Para tu local, feria o food truck',
      minimo: 1, pasos: ['qr_destino', 'qr_donde', 'cantidad', 'qr_logo', 'colores']
    },
    medallas: {
      nombre: 'Medallas y trofeos', ico: ICO.medalla, sub: 'Campeonatos, colegios, empresas',
      minimo: 10, pasos: ['med_evento', 'med_tamano', 'cantidad', 'med_texto', 'med_metales', 'med_cinta']
    },
    letrero: {
      nombre: 'Letrero o logo 3D', ico: ICO.placa, sub: 'Para el mostrador o la pared',
      minimo: 1, pasos: ['let_que', 'let_tamano', 'let_donde', 'colores']
    },
    otro: {
      nombre: 'Otro proyecto', ico: ICO.pieza, sub: 'Cuéntanos qué tienes en mente',
      minimo: 1, pasos: ['otro_tipo', 'otro_idea', 'otro_cantidad', 'otro_tamano', 'otro_modelo', 'colores']
    }
  };

  var ORDEN = ['posavasos', 'llaveros', 'qr', 'medallas', 'letrero', 'otro'];

  /* Qué paso define el tamaño de cada producto. Los que no están acá cotizan
     sin tamaño: el letrero ya trae el suyo con precio propio, y el QR y "otro"
     se cotizan a mano. */
  var TAM_PASO = { posavasos: 'posa_tamano', llaveros: 'lla_tamano', medallas: 'med_tamano' };

  var COLORES = [
    ['Negro', '#1a1a1a'], ['Blanco', '#ffffff'], ['Morado', '#5b21b6'], ['Azul', '#2563eb'],
    ['Rojo', '#dc2626'], ['Verde', '#16a34a'], ['Naranjo', '#d97706'], ['Rosado', '#ec4899'],
    ['Amarillo', '#eab308'], ['Café / Madera', '#d4a373'], ['Plateado / Seda', '#c0c0c0'],
    ['Dorado / Seda', '#d4af37']
  ];

  /* ---------- Preguntas ---------- */
  var PASOS = {

    posa_que: {
      tipo: 'ops', label: 'Diseño', q: '¿Qué va impreso en el <span>posavaso</span>?',
      ops: [
        { v: 'Mi logo', ico: ICO.etiqueta },
        { v: 'Una frase', ico: ICO.frase },
        { v: 'Un diseño que ya tengo', ico: ICO.imagen },
        { v: 'Ayúdenme a crearlo', ico: ICO.magia }
      ]
    },
    lla_que: {
      tipo: 'ops', label: 'Diseño', q: '¿Qué lleva el <span>llavero</span>?',
      ops: [
        { v: 'Un nombre', ico: ICO.letras },
        { v: 'Mi logo', ico: ICO.etiqueta },
        { v: 'Una figura o personaje', ico: ICO.figura },
        { v: 'Un texto corto', ico: ICO.frase }
      ]
    },
    lla_iguales: {
      tipo: 'ops', label: 'Repetición', q: '¿Todos iguales o cada uno distinto?',
      sub: 'Si cada uno lleva un nombre, después te pedimos la lista por WhatsApp.', cols: 1,
      ops: [
        { v: 'Todos iguales', ico: ICO.lista, sub: 'El mismo diseño repetido' },
        { v: 'Cada uno con su nombre', ico: ICO.personas, sub: 'Nos pasas la lista después' }
      ]
    },

    qr_destino: {
      tipo: 'ops', label: 'El QR lleva a', q: '¿A dónde tiene que llevar el <span>QR</span>?',
      ops: [
        { v: 'Mi Instagram', ico: ICO.camara },
        { v: 'Mi web o tienda', ico: ICO.web },
        { v: 'Un menú digital', ico: ICO.menu },
        { v: 'Un link de pago', ico: ICO.pago },
        { v: 'Mi WhatsApp', ico: ICO.frase },
        { v: 'Varias cosas a la vez', ico: ICO.enlace }
      ]
    },
    qr_donde: {
      tipo: 'ops', label: 'Dónde va', q: '¿Dónde lo vas a poner?',
      ops: [
        { v: 'En el mostrador', ico: ICO.mostrador },
        { v: 'En las mesas', ico: ICO.mesa },
        { v: 'En la feria o el stand', ico: ICO.feria },
        { v: 'En el food truck', ico: ICO.camion },
        { v: 'En la pared', ico: ICO.pared },
        { v: 'Todavía no sé', ico: ICO.duda }
      ]
    },
    qr_logo: {
      tipo: 'ops', label: 'Logo', q: '¿Lleva tu logo además del QR?', cols: 1,
      ops: [
        { v: 'Sí, y tengo el archivo', ico: ICO.listo, sub: 'PNG, SVG, lo que tengas' },
        { v: 'Sí, pero no tengo el archivo', ico: ICO.lupa, sub: 'Lo sacamos de tus redes' },
        { v: 'No, solo el QR', ico: ICO.solo }
      ]
    },

    med_evento: {
      tipo: 'ops', label: 'Evento', q: '¿Para qué <span>evento</span> son?',
      ops: [
        { v: 'Un campeonato', ico: ICO.balon },
        { v: 'Un colegio', ico: ICO.colegio },
        { v: 'Un gimnasio o academia', ico: ICO.gimnasio },
        { v: 'Una empresa', ico: ICO.empresa },
        { v: 'Un cumpleaños', ico: ICO.cumple },
        { v: 'Otro', ico: ICO.pieza }
      ]
    },
    med_texto: {
      tipo: 'texto', label: 'Texto', q: '¿Qué dice la medalla?',
      sub: 'El nombre del campeonato, el año, la categoría. Lo que ya tengas decidido.',
      ph: 'Ej: Copa Interbarrios 2026', opcional: true
    },
    med_metales: {
      tipo: 'ops', label: 'Puestos', q: '¿Oro, plata y bronce o todas iguales?', cols: 1,
      ops: [
        { v: 'Los tres puestos', ico: ICO.podio, sub: 'Oro, plata y bronce' },
        { v: 'Todas iguales', ico: ICO.medalla, sub: 'Un solo color' },
        { v: 'Todavía no lo decido', ico: ICO.duda }
      ]
    },
    med_cinta: {
      tipo: 'ops', label: 'Cinta', q: '¿Van con cinta para el cuello?',
      ops: [
        { v: 'Sí, con cinta', ico: ICO.cinta },
        { v: 'No, solo la medalla', ico: ICO.solo }
      ]
    },

    let_que: {
      tipo: 'ops', label: 'Contenido', q: '¿Qué va en el <span>letrero</span>?', cols: 1,
      ops: [
        { v: 'Mi logo', ico: ICO.etiqueta },
        { v: 'El nombre del local', ico: ICO.letras },
        { v: 'Logo y nombre juntos', ico: ICO.puzzle }
      ]
    },
    let_tamano: {
      tipo: 'ops', label: 'Tamaño', q: '¿De qué tamaño lo quieres?', cols: 1,
      ops: [
        { v: 'Hasta 20 cm de ancho', ico: ICO.tamS, sub: 'Para el mostrador o una repisa', precio: 'chico' },
        { v: 'Hasta 35 cm de ancho', ico: ICO.tamM, sub: 'Se ve desde la vereda', precio: 'grande' },
        { v: 'Más grande', ico: ICO.tamL, sub: 'Eso lo cotizamos aparte' }
      ]
    },
    let_donde: {
      tipo: 'ops', label: 'Dónde va', q: '¿Dónde lo vas a poner?',
      ops: [
        { v: 'En el mostrador', ico: ICO.mostrador },
        { v: 'En la pared', ico: ICO.pared },
        { v: 'En la vitrina', ico: ICO.vitrina },
        { v: 'Para fotos de producto', ico: ICO.camara }
      ]
    },

    otro_tipo: {
      tipo: 'ops', label: 'Tipo de pieza', q: '¿Qué tipo de <span>pieza</span> es?',
      ops: [
        { v: 'Figura o personaje', ico: ICO.figura },
        { v: 'Decoración', ico: ICO.magia },
        { v: 'Copa o trofeo', ico: ICO.trofeo },
        { v: 'Un repuesto', ico: ICO.repuesto },
        { v: 'Cajita u organizador', ico: ICO.caja },
        { v: 'Otra cosa', ico: ICO.pieza }
      ]
    },
    otro_idea: {
      tipo: 'parrafo', label: 'La idea', q: 'Cuéntanos tu <span>idea</span>',
      sub: 'Mientras más concreto, mejor te podemos cotizar.',
      ph: 'Ej: una figura de mi gato, de unos 15 cm, para el escritorio',
      requerido: true
    },
    otro_cantidad: {
      tipo: 'ops', label: 'Cantidad', q: '¿Cuántas necesitas?',
      ops: [
        { v: 'Una sola', ico: ICO.cant1 },
        { v: 'Entre 2 y 5', ico: ICO.cant3 },
        { v: 'Entre 6 y 20', ico: ICO.cant6 },
        { v: 'Más de 20', ico: ICO.cantN }
      ]
    },
    otro_tamano: {
      tipo: 'ops', label: 'Tamaño', q: '¿De qué tamaño?',
      ops: [
        { v: 'Pequeño', ico: ICO.tamS, sub: 'hasta 8 cm' },
        { v: 'Mediano', ico: ICO.tamM, sub: '8 a 20 cm' },
        { v: 'Grande', ico: ICO.tamL, sub: 'más de 20 cm' },
        { v: 'No sé, asesórenme', ico: ICO.duda }
      ]
    },
    otro_modelo: {
      tipo: 'ops', label: 'Modelo 3D', q: '¿Tienes el modelo 3D?', cols: 1,
      ops: [
        { v: 'Sí, tengo el archivo STL', ico: ICO.pieza, sub: 'Lo imprimimos directo' },
        { v: 'Vi uno en internet', ico: ICO.enlace, sub: 'Nos pasas el link' },
        { v: 'No, hay que modelarlo', ico: ICO.modelar, sub: 'Lo hacemos nosotros' }
      ]
    },

    /* Los tres tamaños mueven el precio: el mediano es el de siempre, el chico
       baja y el grande sube (lo definen los ajustes de la sección). "Otro
       tamaño" va sin precio a propósito: si no sabemos de qué porte es, un
       estimado en pantalla es inventar. */
    posa_tamano: {
      tipo: 'ops', label: 'Tamaño', q: '¿De qué <span>tamaño</span>?', cols: 1,
      ops: [
        { v: 'Pequeño', ico: ICO.tamS, sub: 'hasta 8 cm, para vaso o tazón chico', precio: 'peq' },
        { v: 'Mediano', ico: ICO.tamM, sub: '9 a 10 cm, el que más se pide', precio: 'med' },
        { v: 'Grande', ico: ICO.tamL, sub: '11 a 12 cm, para schop o jarro', precio: 'gra' },
        { v: 'Otro tamaño', ico: ICO.regla, sub: 'lo conversamos y te cotizamos' }
      ]
    },
    lla_tamano: {
      tipo: 'ops', label: 'Tamaño', q: '¿De qué <span>tamaño</span>?', cols: 1,
      ops: [
        { v: 'Pequeño', ico: ICO.tamS, sub: 'hasta 3 cm, un llaverito discreto', precio: 'peq' },
        { v: 'Mediano', ico: ICO.tamM, sub: '4 a 6 cm, el que más se pide', precio: 'med' },
        { v: 'Grande', ico: ICO.tamL, sub: '7 a 9 cm, se lee de lejos', precio: 'gra' },
        { v: 'Otro tamaño', ico: ICO.regla, sub: 'lo conversamos y te cotizamos' }
      ]
    },
    med_tamano: {
      tipo: 'ops', label: 'Tamaño', q: '¿De qué <span>tamaño</span>?', cols: 1,
      ops: [
        { v: 'Pequeño', ico: ICO.tamS, sub: 'hasta 5 cm', precio: 'peq' },
        { v: 'Mediano', ico: ICO.tamM, sub: '6 a 7 cm, el clásico de campeonato', precio: 'med' },
        { v: 'Grande', ico: ICO.tamL, sub: '8 a 10 cm, para la premiación', precio: 'gra' },
        { v: 'Otro tamaño', ico: ICO.regla, sub: 'lo conversamos y te cotizamos' }
      ]
    },

    cantidad: {
      tipo: 'cantidad', label: 'Cantidad', q: '¿Cuántas <span>unidades</span> necesitas?',
      sub: 'Mientras más pidas, menos te sale cada una.'
    },
    colores: {
      tipo: 'colores', label: 'Colores', q: '¿Qué <span>colores</span> quieres?',
      sub: 'Elige los que te acomoden. Si no estás seguro, sáltalo y lo vemos juntos.',
      opcional: true
    },
    referencia: {
      tipo: 'referencia', label: 'Referencia', q: '¿Tienes alguna <span>referencia</span>?',
      sub: 'Hasta tres archivos y tres links. Si va con logo, mándanos el vector (SVG, AI, EPS o PDF): con una captura de pantalla el borde sale pixelado y hay que redibujarlo entero. Súbelo junto a una foto con los colores, así sabemos qué color va dónde.',
      opcional: true
    },
    plazo: {
      tipo: 'ops', label: 'Plazo', q: '¿Para cuándo lo necesitas?', cols: 1,
      ops: [
        { v: 'Sin apuro', ico: ICO.hoja, sub: 'más de 7 días' },
        { v: 'Normal', ico: ICO.reloj, sub: '3 a 7 días' },
        { v: 'Urgente', ico: ICO.rayo, sub: '1 a 2 días' }
      ]
    },
    contacto: {
      tipo: 'contacto', label: 'Contacto', q: '¿Cómo te <span>contactamos</span>?',
      sub: 'Te llega la cotización por el canal que prefieras.'
    },
    resumen: {
      tipo: 'resumen', label: 'Resumen', q: 'Revisa que esté <span>todo bien</span>',
      sub: 'Toca cualquier línea si quieres cambiarla.'
    }
  };

  var COMUNES = ['referencia', 'plazo', 'contacto', 'resumen'];

  /* Donde queda el resumen mientras Shopify recarga la página tras el envío. */
  var LLAVE_ENVIO = 'crealis-cotizacion-enviada';

  /* ---------- Utilidades ---------- */
  function pesos(n) {
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* Los precios terminan en 990. Se redondea hacia arriba para no comerse el
     margen que dejó calculado el cotizador. */
  function a990(n) {
    if (n <= 990) return 990;
    return Math.ceil((n - 990) / 1000) * 1000 + 990;
  }

  /* Redondea un precio POR UNIDAD al múltiplo de $10 terminado en 90 más
     cercano ($790, $1.190, $2.090). Va sobre la unidad y nunca sobre el total:
     ver el comentario de calcPrecio. */
  function a90(n) {
    if (n <= 90) return 90;
    return Math.round((n - 90) / 100) * 100 + 90;
  }

  function leerTramos(txt) {
    var out = [];
    String(txt || '').split(',').forEach(function (par) {
      var p = par.split(':');
      var desde = parseInt(p[0], 10);
      var precio = parseInt(p[1], 10);
      if (!isNaN(desde) && !isNaN(precio)) out.push({ desde: desde, precio: precio });
    });
    out.sort(function (a, b) { return a.desde - b.desde; });
    return out;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- Archivos que sí llegan ----------
     Antes los adjuntos no salían nunca de este navegador: al Hub viajaban solo
     los nombres, así que el logo del cliente se perdía y había que pedírselo
     por WhatsApp. Ahora la foto se achica acá mismo y viaja dentro de la
     solicitud, sin servidor de archivos de por medio.

     Se comprime al adjuntar, no al enviar: el envío no puede esperar a un
     proceso asíncrono porque la página navega antes y el fetch se pierde.

     El tope existe porque un documento de Firestore no puede pasar 1 MB, y
     base64 infla el peso como un tercio. */
  var MAX_LADO = 1200;       /* px del lado largo de la foto ya achicada */
  var CALIDAD = 0.72;        /* jpeg: bajo esto se empiezan a ver los bloques */
  var TOPE_SVG = 200000;     /* un SVG más pesado que esto no es un logo */
  var TOPE_TOTAL = 700000;   /* bytes de base64 sumando todas las imágenes */

  function comprimir(f, listo) {
    var esSvg = /svg/i.test(f.type) || /\.svg$/i.test(f.name);
    var esFoto = /^image\//.test(f.type) && !esSvg;

    /* El SVG ya es liviano y recomprimirlo lo arruinaría: va tal cual. */
    if (esSvg) {
      if (f.size > TOPE_SVG) return listo(null);
      var rs = new FileReader();
      rs.onload = function () { listo(String(rs.result)); };
      rs.onerror = function () { listo(null); };
      rs.readAsDataURL(f);
      return;
    }
    /* PDF, AI y EPS no caben ni se pueden achicar acá: siguen yendo por el
       canal de siempre y el Hub avisa que están pendientes. */
    if (!esFoto) return listo(null);

    var img = new Image();
    var url = URL.createObjectURL(f);
    img.onload = function () {
      var escala = Math.min(1, MAX_LADO / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.round(img.width * escala);
      c.height = Math.round(img.height * escala);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      try { listo(c.toDataURL('image/jpeg', CALIDAD)); }
      catch (err) { listo(null); }   /* canvas manchado o formato raro */
    };
    img.onerror = function () { URL.revokeObjectURL(url); listo(null); };
    img.src = url;
  }

  /* ---------- Montaje ---------- */
  function montar(raiz) {
    if (raiz.dataset.wzListo) return;
    raiz.dataset.wzListo = '1';

    var cfg = { mostrarPrecio: true, whatsapp: '56982532058', precios: {}, letrero: {} };
    var cfgNodo = raiz.querySelector('[data-wz-config]');
    if (cfgNodo) { try { cfg = JSON.parse(cfgNodo.textContent); } catch (e) {} }

    var vista     = raiz.querySelector('[data-wz-vista]');
    var form      = raiz.querySelector('form');
    var btnAtras  = raiz.querySelector('[data-wz-atras]');
    var barra     = raiz.querySelector('[data-wz-barra]');
    var barraFill = raiz.querySelector('[data-wz-barra-fill]');
    var cuenta    = raiz.querySelector('[data-wz-cuenta]');
    var cajaP     = raiz.querySelector('[data-wz-precio]');
    var pTotal    = raiz.querySelector('[data-wz-precio-total]');
    var pUnidad   = raiz.querySelector('[data-wz-precio-unidad]');
    if (!vista || !form) return;

    var resp = {};
    var preset = null;
    var idx = 0;
    var enviado = false;
    var archivos = [];             /* hasta 3 referencias adjuntas */
    var enlaces = [''];            /* hasta 3 links */
    var volverAlResumen = false;   /* se activa al editar desde el resumen */
    var hubHuella = '';            /* datos del último envío al Hub, para no repetirlo */
    var hubOk = null;              /* null = sin respuesta todavía, false = falló */
    var MAX_REF = 3;

    function flujo() {
      if (!preset) return ['inicio'];
      return ['inicio'].concat(PRESETS[preset].pasos, COMUNES);
    }
    function idActual() { return flujo()[idx]; }
    function val(sel) { var el = vista.querySelector(sel); return el ? el.value.trim() : ''; }

    /* Lee los links que estén en pantalla sin perder los vacíos del medio. */
    function leerEnlaces() {
      var campos = vista.querySelectorAll('[data-link]');
      if (!campos.length) return;
      enlaces = [].map.call(campos, function (i) { return i.value.trim(); });
      if (!enlaces.length) enlaces = [''];
    }

    function leerContacto() {
      if (!vista.querySelector('#wz-nombre')) return;
      resp.contacto_nombre = val('#wz-nombre');
      resp.contacto_tel    = val('#wz-tel');
      resp.contacto_ig     = val('#wz-ig');
      resp.contacto_mail   = val('#wz-mail');
    }

    /* Texto de las referencias para el resumen y el correo. */
    function refTexto() {
      return archivos.map(function (a) { return a.nombre; })
        .concat(enlaces.filter(Boolean))
        .join(' · ');
    }

    /* ----- Precio ----- */
    function calcPrecio() {
      if (!cfg.mostrarPrecio || !preset) return null;

      if (preset === 'letrero') {
        var clave = resp.let_tamano_precio;
        if (!clave || !cfg.letrero[clave]) return null;
        return { total: a990(cfg.letrero[clave]), unidad: cfg.letrero[clave], cantidad: 1 };
      }

      var tramos = leerTramos(cfg.precios[preset]);
      var cant = parseInt(resp.cantidad, 10);
      if (!tramos.length || !cant || cant < 1) return null;

      var uniP = tramos[0].precio;
      for (var i = 0; i < tramos.length; i++) {
        if (cant >= tramos[i].desde) uniP = tramos[i].precio;
      }

      /* El tamaño mueve el precio: el mediano es el de la tabla, el chico baja
         y el grande sube. Si el producto tiene paso de tamaño y la persona
         eligió "Otro tamaño" (o todavía no eligió), no devolvemos estimado: una
         cifra en pantalla sin saber el porte de la pieza es inventar. */
      var pasoTam = TAM_PASO[preset];
      if (pasoTam) {
        var t = cfg.tamanos || {};
        var mult = { peq: (t.peq || 80) / 100, med: 1, gra: (t.gra || 130) / 100 }[resp[pasoTam + '_precio']];
        if (!mult) return null;
        uniP = uniP * mult;
      }

      /* Se redondea la UNIDAD y el total sale de multiplicar. Antes era al
         revés: se redondeaba el total hacia arriba con a990() y la unidad se
         sacaba dividiendo, lo que traía dos problemas. Uno, el precio por
         unidad subía al pedir más dentro del mismo tramo (25 u salía a $1.800
         y 26 u a $1.810), porque el redondeo del total se repartía entre otra
         cantidad de piezas. Dos, unidad × cantidad no daba el total, así que
         el cliente sacaba la cuenta y no le calzaba. */
      /* El precio se elige entre TODOS los tramos: para cada uno se calcula lo
         que costaría llevar el máximo entre lo pedido y el mínimo de ese tramo,
         y gana el más barato. Así se cumplen tres cosas que antes no se
         cumplían ninguna:

           1. El total nunca baja al pedir más.
           2. El precio por unidad nunca sube al pedir más (antes 25 u salían a
              $1.800 c/u y 26 u a $1.810, porque se redondeaba el total y se
              dividía).
           3. unidad × cantidad da exactamente el total, así que al cliente le
              calza si saca la cuenta.

         Cuando gana un tramo más alto que lo pedido se cotiza esa cantidad y se
         avisa en pantalla: pedir 49 costaba más que pedir 50, así que ahora se
         cotizan 50 y se dice por qué. */
      var mejorU = a90(uniP);
      var mejorQ = cant;
      for (var j = 0; j < tramos.length; j++) {
        var tU = a90(tramos[j].precio * (mult || 1));
        var tQ = Math.max(cant, tramos[j].desde);
        if (tU * tQ < mejorU * mejorQ) { mejorU = tU; mejorQ = tQ; }
      }

      return {
        total: mejorU * mejorQ,
        unidad: mejorU,
        cantidad: mejorQ,
        subioA: mejorQ > cant ? mejorQ : 0
      };
    }

    function pintarPrecio() {
      var p = calcPrecio();
      var enLinea = vista.querySelector('[data-wz-precio-linea]');
      if (!p || enviado) {
        cajaP.hidden = true;
        if (enLinea) enLinea.hidden = true;
        return;
      }
      var total = '≈ ' + pesos(p.total);
      var unidad = p.cantidad > 1 ? pesos(p.unidad) + ' cada una' : 'por unidad';
      /* Si se subió la cantidad porque salía más barato, hay que decirlo: si no,
         el cliente ve un total que no calza con lo que pidió. */
      if (p.subioA) unidad += ' · cotizado por ' + p.subioA + ', te sale lo mismo o menos';
      /* Si el precio ya va dentro de la pregunta, el bloque de abajo sobra. */
      cajaP.hidden = !!enLinea;
      pTotal.textContent = total;
      pUnidad.textContent = unidad;
      if (enLinea) {
        enLinea.hidden = false;
        enLinea.querySelector('[data-wz-precio-total]').textContent = total;
        enLinea.querySelector('[data-wz-precio-unidad]').textContent = unidad;
      }
    }

    /* ----- Cabecera ----- */
    function pintarTop() {
      var total = flujo().length;
      var n = idx + 1;
      btnAtras.hidden = idx === 0;
      var pct = preset ? Math.round((n / total) * 100) : 6;
      barraFill.style.width = pct + '%';
      barra.setAttribute('aria-valuenow', String(pct));
      cuenta.textContent = preset ? n + ' / ' + total : '';
    }

    /* ----- Navegación ----- */
    /* modo: 'push' (por defecto), 'reemplazar' o 'nada'.
       El salto desde el resumen reemplaza la entrada en vez de apilarla, si no
       el botón atrás del navegador termina llevando de vuelta al resumen. */
    function ir(n, dir, modo) {
      idx = Math.min(Math.max(0, n), flujo().length - 1);
      pintar(dir || 'der');
      try {
        if (modo === 'reemplazar') history.replaceState({ wz: idx }, '');
        else if (modo !== 'nada') history.pushState({ wz: idx }, '');
      } catch (e) {}
    }

    function siguiente() {
      if (volverAlResumen) {
        volverAlResumen = false;
        ir(flujo().length - 1, 'der');
        return;
      }
      if (idx < flujo().length - 1) ir(idx + 1, 'der');
    }

    window.addEventListener('popstate', function (e) {
      if (enviado || !raiz.isConnected) return;
      var destino = (e.state && typeof e.state.wz === 'number') ? e.state.wz : idx - 1;
      if (destino < 0) return;
      volverAlResumen = false;
      ir(destino, destino < idx ? 'izq' : 'der', 'nada');
    });

    btnAtras.addEventListener('click', function () {
      if (idx > 0) history.back();
    });

    /* ----- Render ----- */
    /* foco: undefined = el primer campo (solo en escritorio), false = ninguno,
       o un selector para llevar el cursor a un campo puntual. */
    function pintar(dir, foco) {
      var id = idActual();
      vista.innerHTML = id === 'inicio' ? vistaInicio() : vistaPaso(id, PASOS[id]);
      if (vista.firstElementChild) {
        vista.firstElementChild.classList.add(dir === 'izq' ? 'entra-izq' : 'entra-der');
      }
      conectar(id);
      pintarTop();
      pintarPrecio();
      /* Los ocultos se llenan al llegar al resumen y no solo al enviar: el
         script de captcha de Shopify también escucha el submit, y así da lo
         mismo cuál de los dos listeners corra primero. */
      if (id === 'resumen' && preset) { guardarDesdeResumen(); ponerOcultos(); }
      if (foco === false) return;
      var el = foco ? vista.querySelector(foco) : vista.querySelector('input:not([type=file]), textarea');
      if (el && (foco || window.matchMedia('(min-width: 990px)').matches)) el.focus();
    }

    function cabecera(p) {
      return '<p class="wz-eyebrow">' + esc(p.label || '') + '</p>' +
             '<h2 class="wz-q">' + p.q + '</h2>' +
             (p.sub ? '<p class="wz-qsub">' + esc(p.sub) + '</p>' : '');
    }

    function vistaInicio() {
      var cards = ORDEN.map(function (k) {
        var pr = PRESETS[k];
        return '<button type="button" class="wz-op' + (preset === k ? ' on' : '') + '" data-preset="' + k + '">' +
                 '<span class="wz-op__ico">' + pr.ico + '</span>' +
                 '<span class="wz-op__tit">' + esc(pr.nombre) + '</span>' +
                 '<span class="wz-op__sub">' + esc(pr.sub) + '</span>' +
                 '<span class="wz-op__tick">✓</span>' +
               '</button>';
      }).join('');

      return '<div class="wz-pantalla">' +
               '<p class="wz-eyebrow">Cotización sin compromiso</p>' +
               '<h2 class="wz-q">¿Qué quieres <span>hacer</span>?</h2>' +
               '<p class="wz-qsub">Elige uno y te vamos preguntando lo justo. Toma menos de un minuto.</p>' +
               '<div class="wz-ops col3">' + cards + '</div>' +
             '</div>';
    }

    function vistaPaso(id, p) {
      var cuerpo = '';

      if (p.tipo === 'ops') {
        var cols = p.cols === 1 ? ' col1' : (p.ops.length > 4 ? ' col3' : '');
        cuerpo = '<div class="wz-ops' + cols + '">' + p.ops.map(function (o) {
          /* Las opciones con precio propio (los tamaños del letrero) lo muestran
             en el subtítulo: como avanzan solas, si no, nadie alcanza a verlo. */
          var sub = o.sub || '';
          if (o.precio && cfg.mostrarPrecio && cfg.letrero[o.precio]) {
            sub = sub ? sub + ' · ' + pesos(cfg.letrero[o.precio]) : pesos(cfg.letrero[o.precio]);
          }
          return '<button type="button" class="wz-op' + (resp[id] === o.v ? ' on' : '') + '" data-val="' + esc(o.v) + '"' +
                 (o.precio ? ' data-precio="' + esc(o.precio) + '"' : '') + '>' +
                   '<span class="wz-op__ico">' + o.ico + '</span>' +
                   '<span class="wz-op__tit">' + esc(o.v) + '</span>' +
                   (sub ? '<span class="wz-op__sub">' + esc(sub) + '</span>' : '') +
                   '<span class="wz-op__tick">✓</span>' +
                 '</button>';
        }).join('') + '</div>';

      } else if (p.tipo === 'cantidad') {
        var min = PRESETS[preset].minimo;
        var sug = min >= 10 ? [min, min * 2.5, min * 5] : [1, 2, 5];
        cuerpo = '<div class="wz-cant">' + sug.map(function (n) {
          n = Math.round(n);
          return '<button type="button" class="wz-op' + (String(resp.cantidad) === String(n) ? ' on' : '') + '" data-cant="' + n + '">' +
                   '<span class="wz-op__tit">' + n + '</span>' +
                   '<span class="wz-op__sub">unidades</span>' +
                 '</button>';
        }).join('') + '</div>' +
        /* El precio va pegado a los botones, antes del campo libre: así aparece
           donde está mirando la persona apenas toca una cantidad. */
        '<div class="wz-precio wz-precio-en-linea" data-wz-precio-linea hidden>' +
          '<div class="wz-precio__cifra"><strong data-wz-precio-total></strong><span data-wz-precio-unidad></span></div>' +
          '<p class="wz-precio__nota">Precio de referencia. Te lo confirmamos por WhatsApp con el diseño a la vista.</p>' +
        '</div>' +
        '<div class="wz-campo"><label class="wz-label" for="wz-cant-otra">O escribe la cantidad exacta</label>' +
        '<input class="wz-input" type="number" inputmode="numeric" id="wz-cant-otra" min="' + min + '" placeholder="Ej: 40" value="' + esc(resp.cantidad || '') + '"></div>' +
        (min > 1 ? '<p class="wz-hint">Los pedidos personalizados parten en ' + min + ' unidades.</p>' : '');

      } else if (p.tipo === 'colores') {
        var elegidos = (resp.colores || '').split(', ').filter(Boolean);
        cuerpo = '<div class="wz-colores">' + COLORES.map(function (c) {
          var on = elegidos.indexOf(c[0]) > -1;
          var borde = c[1] === '#ffffff' ? ';border-color:#e5e7eb' : '';
          return '<button type="button" class="wz-color' + (on ? ' on' : '') + '" style="background:' + c[1] + borde + '" data-color="' + esc(c[0]) + '" title="' + esc(c[0]) + '" aria-label="' + esc(c[0]) + '"></button>';
        }).join('') + '</div>' +
        '<p class="wz-hint">¿No está el tuyo? Escríbelo en la referencia y lo conseguimos.</p>';

      } else if (p.tipo === 'texto') {
        cuerpo = '<input class="wz-input" type="text" id="wz-campo" placeholder="' + esc(p.ph || '') + '" value="' + esc(resp[id] || '') + '">';

      } else if (p.tipo === 'parrafo') {
        cuerpo = '<textarea class="wz-textarea" id="wz-campo" placeholder="' + esc(p.ph || '') + '">' + esc(resp[id] || '') + '</textarea>';

      } else if (p.tipo === 'referencia') {
        var listaArch = archivos.map(function (a, i) {
          return '<div class="wz-previa">' +
                   (a.url
                     ? '<img src="' + esc(a.url) + '" alt="">'
                     : '<span class="wz-previa__ico">' + (a.vector ? '📐' : '📄') + '</span>') +
                   '<span class="wz-previa__nom">' + esc(a.nombre) + '</span>' +
                   '<button type="button" class="wz-previa__x" data-quitar="' + i + '" aria-label="Quitar ' + esc(a.nombre) + '">✕</button>' +
                 '</div>';
        }).join('');

        var listaLinks = enlaces.map(function (u, i) {
          return '<div class="wz-linea">' +
                   '<input class="wz-input" type="url" data-link="' + i + '" placeholder="Pinterest, Instagram, MakerWorld…" value="' + esc(u) + '">' +
                   (enlaces.length > 1 ? '<button type="button" class="wz-previa__x" data-quitar-link="' + i + '" aria-label="Quitar este link">✕</button>' : '') +
                 '</div>';
        }).join('');

        cuerpo =
          '<div class="wz-campo">' +
            listaArch +
            (archivos.length < MAX_REF
              ? '<div class="wz-drop" data-drop><p class="wz-drop__tit">' +
                (archivos.length ? 'Agregar otro archivo' : 'Sube tus archivos') +
                '</p><p class="wz-drop__sub">JPG, PNG, SVG, PDF. Quedan ' + (MAX_REF - archivos.length) + ' de ' + MAX_REF + '.</p></div>'
              : '<p class="wz-hint">Ya van tres, que es el tope. Si necesitas mandar más, nos los pasas por WhatsApp.</p>') +
            '<input type="file" accept="image/*,.svg,.pdf,.ai,.eps" multiple data-archivo hidden>' +
          '</div>' +
          '<div class="wz-campo"><label class="wz-label">O pega links</label>' +
            listaLinks +
            (enlaces.length < MAX_REF ? '<button type="button" class="wz-mas" data-mas-link>+ Agregar otro link</button>' : '') +
          '</div>' +
          '<p class="wz-hint">Los archivos quedan en tu teléfono: al final te dejamos el botón de WhatsApp con todo escrito para mandárnoslos en un toque.</p>';

      } else if (p.tipo === 'contacto') {
        var canal = resp.contacto_canal || 'WhatsApp';
        /* Solo el dato del canal elegido es obligatorio; los otros dos quedan
           marcados como opcionales para que nadie se trabe rellenando de más. */
        var marca = function (c) {
          return canal === c ? '' : ' <span class="wz-opt">(opcional)</span>';
        };
        cuerpo =
          '<div class="wz-campo"><label class="wz-label" for="wz-nombre">Tu nombre</label>' +
          '<input class="wz-input" type="text" id="wz-nombre" autocomplete="name" placeholder="Cómo te decimos" value="' + esc(resp.contacto_nombre || '') + '"></div>' +
          '<div class="wz-campo"><label class="wz-label">¿Por dónde prefieres que te respondamos?</label>' +
          '<div class="wz-ops chips">' + ['WhatsApp', 'Instagram', 'Correo'].map(function (c) {
            return '<button type="button" class="wz-op" data-canal-val="' + c + '"' + (canal === c ? ' data-on="1"' : '') + '>' +
                     '<span class="wz-op__tit">' + c + '</span><span class="wz-op__tick">✓</span></button>';
          }).join('') + '</div></div>' +
          '<div class="wz-campo"><label class="wz-label" for="wz-tel">WhatsApp' + marca('WhatsApp') + '</label>' +
          '<input class="wz-input" type="tel" id="wz-tel" autocomplete="tel" inputmode="tel" placeholder="+56 9 XXXX XXXX" value="' + esc(resp.contacto_tel || '') + '"></div>' +
          '<div class="wz-campo"><label class="wz-label" for="wz-ig">Instagram' + marca('Instagram') + '</label>' +
          '<input class="wz-input" type="text" id="wz-ig" autocapitalize="off" spellcheck="false" placeholder="@tucuenta" value="' + esc(resp.contacto_ig || '') + '"></div>' +
          '<div class="wz-campo"><label class="wz-label" for="wz-mail">Correo' + marca('Correo') + '</label>' +
          '<input class="wz-input" type="email" id="wz-mail" autocomplete="email" spellcheck="false" placeholder="tu@correo.com" value="' + esc(resp.contacto_mail || '') + '"></div>' +
          '<p class="wz-error" data-err hidden></p>';

      } else if (p.tipo === 'resumen') {
        cuerpo = '<div class="wz-res">' + filasResumen().map(function (f) {
          return '<button type="button" class="wz-res__fila" data-saltar-a="' + esc(f.id) + '">' +
                   '<span class="wz-res__k">' + esc(f.k) + '</span>' +
                   '<span class="wz-res__v">' + esc(f.v) + '</span>' +
                   '<span class="wz-res__lapiz">cambiar</span>' +
                 '</button>';
        }).join('') + '</div>' +
        '<div class="wz-aviso"><span>💬</span><p>Esto es una solicitud de cotización, no un pago. Te respondemos con el precio final, el plazo y las dudas que tengamos.</p></div>' +
        '<p class="wz-error" data-err hidden></p>';
      }

      var nav = '';
      if (p.tipo === 'ops') {
        nav = '';
      } else if (p.tipo === 'resumen') {
        nav = '<div class="wz-nav"><button type="submit" class="wz-btn primary wz-crece">Enviar solicitud</button></div>';
      } else {
        nav = '<div class="wz-nav">' +
                (p.opcional ? '<button type="button" class="wz-saltar" data-saltar>Saltar</button>' : '') +
                '<button type="button" class="wz-btn primary wz-crece" data-seguir>Continuar</button>' +
              '</div>';
      }

      return '<div class="wz-pantalla">' + cabecera(p) + cuerpo + nav + '</div>';
    }

    /* ----- Resumen ----- */
    function filasResumen() {
      var filas = [{ id: 'inicio', k: 'Producto', v: PRESETS[preset].nombre }];
      PRESETS[preset].pasos.concat(['referencia', 'plazo']).forEach(function (id) {
        var p = PASOS[id];
        if (!p) return;
        var v = id === 'referencia' ? refTexto() : resp[id];
        if (!v) return;
        filas.push({ id: id, k: p.label, v: v });
      });
      var pr = calcPrecio();
      if (pr) filas.push({ id: preset === 'letrero' ? 'let_tamano' : 'cantidad', k: 'Estimado', v: '≈ ' + pesos(pr.total) });
      filas.push({
        id: 'contacto', k: 'Contacto',
        v: [resp.contacto_nombre, resp.contacto_tel, resp.contacto_ig, resp.contacto_mail].filter(Boolean).join(' · ')
      });
      filas.push({ id: 'contacto', k: 'Te escribimos por', v: resp.contacto_canal || 'WhatsApp' });
      return filas;
    }

    /* ----- Eventos ----- */
    function conectar(id) {
      var p = PASOS[id];

      vista.querySelectorAll('[data-preset]').forEach(function (b) {
        b.addEventListener('click', function () {
          var nuevo = b.dataset.preset;
          var cambio = preset && preset !== nuevo;
          if (cambio) { resp = {}; archivos = []; enlaces = ['']; volverAlResumen = false; }
          preset = nuevo;
          vista.querySelectorAll('[data-preset]').forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          setTimeout(function () {
            /* Si venía del resumen y no cambió de producto, lo devolvemos ahí. */
            if (volverAlResumen) { volverAlResumen = false; ir(flujo().length - 1, 'der'); }
            else ir(1, 'der');
          }, 170);
        });
      });

      vista.querySelectorAll('[data-val]').forEach(function (b) {
        b.addEventListener('click', function () {
          vista.querySelectorAll('[data-val]').forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          resp[id] = b.dataset.val;
          if (b.dataset.precio) resp[id + '_precio'] = b.dataset.precio;
          else delete resp[id + '_precio'];
          pintarPrecio();
          setTimeout(siguiente, 190);
        });
      });

      var inputCant = vista.querySelector('#wz-cant-otra');
      vista.querySelectorAll('[data-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          vista.querySelectorAll('[data-cant]').forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          resp.cantidad = b.dataset.cant;
          if (inputCant) inputCant.value = b.dataset.cant;
          /* Este paso NO avanza solo: la gracia es alcanzar a leer el precio
             que aparece abajo antes de seguir. */
          pintarPrecio();
        });
      });
      if (inputCant) {
        inputCant.addEventListener('input', function () {
          resp.cantidad = inputCant.value;
          vista.querySelectorAll('[data-cant]').forEach(function (o) {
            o.classList.toggle('on', o.dataset.cant === inputCant.value);
          });
          pintarPrecio();
        });
      }

      vista.querySelectorAll('[data-color]').forEach(function (b) {
        b.addEventListener('click', function () {
          b.classList.toggle('on');
          var sel = [];
          vista.querySelectorAll('[data-color].on').forEach(function (o) { sel.push(o.dataset.color); });
          resp.colores = sel.join(', ');
        });
      });

      vista.querySelectorAll('[data-canal-val]').forEach(function (b) {
        if (b.dataset.on) b.classList.add('on');
        b.addEventListener('click', function () {
          leerContacto();                       /* no perder lo ya escrito */
          resp.contacto_canal = b.dataset.canalVal;
          pintar('der', false);                 /* re-pinta las etiquetas */
        });
      });

      var drop = vista.querySelector('[data-drop]');
      var file = vista.querySelector('[data-archivo]');
      if (drop && file) {
        drop.addEventListener('click', function () { file.click(); });
        drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('sobre'); });
        drop.addEventListener('dragleave', function () { drop.classList.remove('sobre'); });
        drop.addEventListener('drop', function (e) {
          e.preventDefault(); drop.classList.remove('sobre');
          tomarArchivos(e.dataTransfer.files);
        });
        file.addEventListener('change', function () { tomarArchivos(file.files); });
      }

      vista.querySelectorAll('[data-quitar]').forEach(function (b) {
        b.addEventListener('click', function () {
          leerEnlaces();
          var i = parseInt(b.dataset.quitar, 10);
          if (archivos[i] && archivos[i].url) URL.revokeObjectURL(archivos[i].url);
          archivos.splice(i, 1);
          pintar('der', false);
        });
      });

      vista.querySelectorAll('[data-quitar-link]').forEach(function (b) {
        b.addEventListener('click', function () {
          leerEnlaces();
          enlaces.splice(parseInt(b.dataset.quitarLink, 10), 1);
          if (!enlaces.length) enlaces = [''];
          pintar('der', false);
        });
      });

      var masLink = vista.querySelector('[data-mas-link]');
      if (masLink) masLink.addEventListener('click', function () {
        leerEnlaces();
        if (enlaces.length < MAX_REF) enlaces.push('');
        pintar('der', '[data-link="' + (enlaces.length - 1) + '"]');
      });

      function tomarArchivos(lista) {
        leerEnlaces();
        [].slice.call(lista || []).forEach(function (f) {
          if (archivos.length >= MAX_REF) return;
          /* El SVG y el PDF no se previsualizan como <img> confiable: van con
             ícono. El resto sí, y es lo que deja ver que subieron lo correcto. */
          var vector = /svg|pdf|postscript|illustrator/i.test(f.type) || /\.(svg|pdf|ai|eps)$/i.test(f.name);
          var raster = /^image\//.test(f.type) && !/svg/i.test(f.type);
          var item = {
            nombre: f.name,
            vector: vector,
            url: raster ? URL.createObjectURL(f) : '',
            b64: null,
            listo: false
          };
          archivos.push(item);
          comprimir(f, function (b64) {
            item.b64 = b64;
            item.listo = true;
            pintar('der', false);
          });
        });
        pintar('der', false);
      }

      vista.querySelectorAll('[data-saltar-a]').forEach(function (b) {
        b.addEventListener('click', function () {
          var destino = flujo().indexOf(b.dataset.saltarA);
          if (destino > -1) { volverAlResumen = true; ir(destino, 'izq', 'reemplazar'); }
        });
      });

      var seguir = vista.querySelector('[data-seguir]');
      if (seguir) seguir.addEventListener('click', function () { guardarYSeguir(id, p); });
      var saltar = vista.querySelector('[data-saltar]');
      if (saltar) saltar.addEventListener('click', function () { guardarYSeguir(id, p, true); });

      vista.querySelectorAll('input:not([type=file])').forEach(function (inp) {
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); guardarYSeguir(id, p); }
        });
      });
    }

    function guardarYSeguir(id, p, saltando) {
      var err = vista.querySelector('[data-err]');
      if (err) { err.hidden = true; err.textContent = ''; }

      if (p.tipo === 'cantidad') {
        var v = parseInt(val('#wz-cant-otra'), 10);
        var min = PRESETS[preset].minimo;
        if (!v || v < min) {
          avisar('Necesitamos al menos ' + min + (min === 1 ? ' unidad.' : ' unidades para un pedido personalizado.'));
          return;
        }
        resp.cantidad = String(v);
        pintarPrecio();

      } else if (p.tipo === 'texto' || p.tipo === 'parrafo') {
        var campo = vista.querySelector('#wz-campo');
        var texto = campo ? campo.value.trim() : '';
        if (p.requerido && !texto && !saltando) {
          avisar('Cuéntanos aunque sea en una línea, así te cotizamos bien.');
          return;
        }
        resp[id] = texto;

      } else if (p.tipo === 'referencia') {
        leerEnlaces();
        resp.referencia_links = enlaces.filter(Boolean).join(' · ');

      } else if (p.tipo === 'contacto') {
        leerContacto();
        var canalElegido = resp.contacto_canal || 'WhatsApp';
        if (!resp.contacto_nombre) { avisar('Nos falta tu nombre.'); return; }
        /* Solo se exige el dato del canal que la persona eligió. */
        if (canalElegido === 'WhatsApp' && !resp.contacto_tel) {
          avisar('Pusiste WhatsApp, así que necesitamos tu número.'); return;
        }
        if (canalElegido === 'Instagram' && !resp.contacto_ig) {
          avisar('Pusiste Instagram, así que necesitamos tu cuenta.'); return;
        }
        if (canalElegido === 'Correo' && resp.contacto_mail.indexOf('@') < 1) {
          avisar('Pusiste correo, así que necesitamos una dirección válida.'); return;
        }
        if (resp.contacto_mail && resp.contacto_mail.indexOf('@') < 1) {
          avisar('Ese correo quedó incompleto. Bórralo o arréglalo.'); return;
        }
      }

      siguiente();
    }

    function avisar(msg) {
      var err = vista.querySelector('[data-err]');
      if (!err) {
        err = document.createElement('p');
        err.className = 'wz-error';
        err.setAttribute('data-err', '');
        var nav = vista.querySelector('.wz-nav');
        if (nav) nav.parentNode.insertBefore(err, nav);
        else vista.firstElementChild.appendChild(err);
      }
      err.hidden = false;
      err.textContent = msg;
    }

    /* ----- Envío ----- */
    function textoResumen() {
      return filasResumen().map(function (f) { return f.k + ': ' + f.v; }).join('\n');
    }

    /* Una sola línea sobre las fotos. El correo de Shopify NO lleva adjuntos:
       las fotos viajan al Hub dentro de la solicitud. Acá se dice cuántas
       llegaron, cuáles no cupieron y qué links dejó, para no tener que abrir
       el Hub solo para saber si mandó algo. */
    function fotosTexto() {
      var pendientes = pendientesDe();
      var subidas = archivos.length - pendientes.length;
      var links = enlaces.filter(Boolean);
      var partes = [];
      if (subidas) {
        partes.push(hubOk === false
          ? subidas + (subidas === 1 ? ' foto' : ' fotos') + ' NO se pudieron guardar: pídelas por ' + (resp.contacto_canal || 'WhatsApp')
          : subidas + (subidas === 1 ? ' foto' : ' fotos') + ' en el Hub, en Solicitudes');
      }
      if (pendientes.length) {
        partes.push('faltan por ' + (resp.contacto_canal || 'WhatsApp') + ': ' + pendientes.join(' · '));
      }
      if (links.length) partes.push('links: ' + links.join(' · '));
      return partes.length ? partes.join(' — ') : 'No adjuntó fotos ni links';
    }

    /* Mete cada respuesta como <input hidden> dentro del form, para que viajen
       en el envío nativo del navegador.

       Cada contact[loquesea] se vuelve una fila del correo de Shopify, así que
       acá va SOLO lo que no está ya dentro de contact[body]: las respuestas del
       cuestionario (tipo, idea, cantidad, tamaño, colores, plazo) ya vienen
       escritas en el resumen, y repetirlas deja el correo con todo dos veces.

       Ojo con los nombres: Shopify traduce el nombre del campo para armar la
       etiqueta, y 'subject' choca con el texto del propio aviso — por eso salía
       "Nuevo mensaje de cliente el %{creation_date}" en medio del correo. Nada
       de 'subject' para campos propios; 'body' sí es especial y sale bien, como
       "Mensaje". */
    function ponerOcultos() {
      var pr = calcPrecio();
      var datos = {
        'contact[name]': resp.contacto_nombre || '',
        'contact[email]': resp.contacto_mail || '',
        'contact[phone]': resp.contacto_tel || '',
        'contact[instagram]': resp.contacto_ig || '',
        'contact[producto]': PRESETS[preset].nombre,
        'contact[canal_preferido]': resp.contacto_canal || 'WhatsApp',
        'contact[estimado]': pr ? pesos(pr.total) + ' (' + pesos(pr.unidad) + ' c/u)' : 'Sin estimado',
        'contact[fotos]': fotosTexto(),
        'contact[body]': textoResumen()
      };

      Object.keys(datos).forEach(function (nombre) {
        var input = form.querySelector('input[type=hidden][name="' + nombre + '"]');
        /* Un campo vacío igual sale como una fila en blanco en el correo. Si no
           hay dato no va — y si quedó de un envío anterior que falló, se saca. */
        if (!datos[nombre]) {
          if (input) input.parentNode.removeChild(input);
          return;
        }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = nombre;
          form.appendChild(input);
        }
        input.value = datos[nombre];
      });
    }

    /* Guarda la solicitud en CrealisHub (Firestore, por REST, sin SDK).
       Va ANTES de todo lo demás a propósito: el correo de Shopify pasa por un
       captcha que puede fallar y no deja rastro cuando falla. Esto sí queda.
       Las reglas de Firestore solo permiten crear en `solicitudes`, y los
       largos de acá tienen que respetar los que validan esas reglas. */
    /* Los que NO alcanzaron a viajar dentro de la solicitud. Se calcula igual
       que el armado de imágenes para que la cuenta que ve el cliente en la
       pantalla final y la que ve el Hub sean la misma. */
    function pendientesDe() {
      var suma = 0;
      var out = [];
      archivos.forEach(function (a) {
        if (a.b64 && suma + a.b64.length <= TOPE_TOTAL) suma += a.b64.length;
        else out.push(a.nombre);
      });
      return out;
    }

    /* conFotos=true es el envío bueno, el que sale desde el resumen sin
       navegación en curso. conFotos=false es el respaldo del submit: liviano a
       propósito, porque ahí sí hay recarga y hace falta keepalive, que corta
       cualquier cuerpo de más de 64 KB. */
    function guardarEnHub(conFotos) {
      var hub = cfg.hub || {};
      if (!hub.proyecto || !hub.clave) return;

      var corta = function (v, n) { return String(v == null ? '' : v).slice(0, n - 1); };
      var pr = calcPrecio();
      var texto = function (v) { return { stringValue: v }; };

      /* Las fotos ya comprimidas, hasta donde alcance el tope. Lo que no cabe
         (un PDF, un vector pesado, la cuarta foto) se queda como pendiente y el
         Hub lo pide aparte: mandarlo a medias sería peor que no mandarlo. */
      var imgs = [];
      var suma = 0;
      if (conFotos) {
        archivos.forEach(function (a) {
          if (a.b64 && suma + a.b64.length <= TOPE_TOTAL) {
            suma += a.b64.length;
            imgs.push({ stringValue: a.b64 });
          }
        });
      }
      var pendientes = pendientesDe();

      var cuerpo = { fields: {
        producto:        texto(corta(PRESETS[preset].nombre, 80)),
        respuestas:      texto(corta(textoResumen(), 4000)),
        estimado:        texto(corta(pr ? pesos(pr.total) : 'Sin estimado', 60)),
        contacto_nombre: texto(corta(resp.contacto_nombre, 120)),
        contacto_tel:    texto(corta(resp.contacto_tel, 40)),
        contacto_ig:     texto(corta(resp.contacto_ig, 80)),
        contacto_mail:   texto(corta(resp.contacto_mail, 120)),
        canal:           texto(corta(resp.contacto_canal || 'WhatsApp', 20)),
        referencias:     texto(corta(refTexto(), 1200)),
        archivos:        texto(corta(pendientes.length ? pendientes.join(' · ') : 'No', 400)),
        estado:          texto('nueva'),
        origen:          texto('web'),
        ts:              { integerValue: String(Date.now()) },
        imagenes:        { arrayValue: { values: imgs } }
      } };

      var url = 'https://firestore.googleapis.com/v1/projects/' + hub.proyecto +
                '/databases/(default)/documents/solicitudes?key=' + encodeURIComponent(hub.clave);

      /* ⚠️ keepalive SOLO en el respaldo del submit. El estándar corta a los
         64 KB el cuerpo de un fetch con keepalive, y una sola foto ya pesa más:
         con fotos, el envío moría dentro del navegador sin salir nunca. */
      try {
        fetch(url, {
          method: 'POST', keepalive: !conFotos,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cuerpo)
        }).then(function (r) {
          hubOk = r.ok;
          if (!r.ok) hubHuella = '';
        }).catch(function () {
          hubOk = false;
          hubHuella = '';
        });
      } catch (err) { hubOk = false; hubHuella = ''; }
    }

    /* La solicitud se guarda al llegar al resumen, no al enviar: ahí no hay
       recarga esperando, así que las fotos caben. Si la persona vuelve atrás,
       corrige algo y regresa, la huella cambia y se guarda de nuevo; si vuelve
       sin tocar nada, no se repite. */
    function guardarDesdeResumen() {
      var huella = textoResumen() + '|' + (resp.contacto_canal || '') + '|' + archivos.length;
      if (huella === hubHuella) return;
      hubHuella = huella;
      hubOk = null;
      guardarEnHub(true);
    }

    form.addEventListener('submit', function (e) {
      if (enviado || !preset) { e.preventDefault(); return; }

      /* Lo normal es que la solicitud ya se haya guardado al llegar al resumen,
         con fotos y todo. Esto es el respaldo para cuando eso falló o todavía
         no confirma: liviano y sin imágenes, porque acá viene la recarga y el
         keepalive corta a los 64 KB. Si los dos llegan quedan dos tarjetas del
         mismo cliente, y eso es mucho mejor que perder la solicitud. */
      if (hubOk !== true) guardarEnHub(false);

      /* Shopify exige contact[email] para aceptar el formulario. Si la persona
         eligió WhatsApp o Instagram y no dejó correo, no hay nada que mandar:
         se pasa al traspaso por su canal en vez de fingir un envío. */
      if (!resp.contacto_mail) { e.preventDefault(); exito(false); return; }

      /* ⚠️ ACÁ NO SE LLAMA preventDefault A PROPÓSITO.
         Shopify protege este formulario con captcha y el token lo agrega su
         propio script durante el envío nativo. Mandarlo por fetch devuelve
         400 "Missing CAPTCHA token" y la solicitud se pierde en silencio.
         Así que se rellenan los ocultos, se guarda el resumen para después de
         la recarga y se deja que el navegador envíe como siempre. */
      ponerOcultos();
      try {
        sessionStorage.setItem(LLAVE_ENVIO, JSON.stringify({
          canal: resp.contacto_canal || 'WhatsApp',
          resumen: textoResumen(),
          archivos: pendientesDe().length,
          ts: Date.now()
        }));
      } catch (err) {}

      var boton = vista.querySelector('button[type=submit]');
      if (boton) boton.textContent = 'Enviando…';

      /* Red de seguridad: el envío pasa por el captcha invisible de Shopify
         (hCaptcha). Si se cuelga o la persona no lo resuelve, la página nunca
         navega y el botón queda en "Enviando…" para siempre. Este temporizador
         solo alcanza a correr si seguimos acá; si el envío sale, la página se
         recarga y se lo lleva puesto. No interrumpe: agrega una salida. */
      setTimeout(function () {
        if (enviado || !vista.querySelector('button[type=submit]')) return;
        if (vista.querySelector('[data-rescate]')) return;
        var msg = 'Hola! Vengo del cotizador de la web.\n\n' + textoResumen();
        var nav = vista.querySelector('.wz-nav');
        if (!nav) return;
        var caja = document.createElement('div');
        caja.setAttribute('data-rescate', '');
        caja.className = 'wz-rescate';
        caja.innerHTML =
          '<p>¿Se quedó pegado? A veces la verificación de seguridad demora. ' +
          'Tu solicitud ya está escrita, mándala por acá y te respondemos igual.</p>' +
          '<a class="wz-btn wa" href="https://wa.me/' + esc(cfg.whatsapp) + '?text=' +
          esc(encodeURIComponent(msg)) + '" target="_blank" rel="noopener">Mandar por WhatsApp</a>';
        nav.parentNode.insertBefore(caja, nav.nextSibling);
      }, 15000);
    });

    /* El portapapeles puede fallar (permiso denegado, http sin candado). Si
       falla, el texto de la pantalla no puede seguir diciendo que copiamos algo:
       se cambia por uno que no promete nada. */
    function copiar(texto) {
      var aviso = function () {
        var p = vista.querySelector('.wz-ok p');
        if (p) p.textContent = 'Te respondemos en menos de 24 horas. Si quieres adelantar, ábrenos el chat de Instagram.';
      };
      try {
        var pr = navigator.clipboard && navigator.clipboard.writeText(texto);
        if (pr && pr.catch) pr.catch(aviso);
        else if (!pr) aviso();
      } catch (e) { aviso(); }
    }

    /* llego = true cuando Shopify aceptó el formulario. Cuando no hay correo no
       hay formulario que aceptar, y el traspaso pasa a ser el canal que eligió
       la persona: la solicitud igual llega, solo que por ahí. */
    /* datos = { canal, resumen, archivos }. Cuando el envío fue nativo la
       página se recargó, así que los datos vienen de sessionStorage y no del
       estado en memoria, que ya se perdió. */
    function exito(llego, datos) {
      if (enviado) return;
      enviado = true;

      datos = datos || { canal: resp.contacto_canal, resumen: textoResumen(), archivos: pendientesDe().length };
      var canal = datos.canal || 'WhatsApp';
      var nArchivos = datos.archivos || 0;
      var msg = 'Hola! Vengo del cotizador de la web.\n\n' + (datos.resumen || '');
      var waUrl = 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(msg);
      var igUrl = 'https://ig.me/m/' + String(cfg.instagram || 'crealis.cl').replace('@', '');
      var faltan = nArchivos
        ? (nArchivos === 1 ? ' Nos falta tu archivo: mándalo por acá.' : ' Nos faltan tus archivos: mándalos por acá.')
        : '';

      /* La solicitud ya quedó guardada en el Hub antes de llegar acá, así que
         el mensaje es el mismo haya pasado o no por el correo de Shopify. El
         botón cambia según el canal que eligió la persona. */
      var ico = '🎉';
      var titulo = 'Listo, ya nos llegó';
      var texto = 'Te respondemos en menos de 24 horas con el precio final y el plazo.' + faltan;
      var boton, aCopiar = '';

      var otroCanal;
      if (canal === 'Instagram') {
        boton = '<a class="wz-btn primary wz-crece" href="' + esc(igUrl) + '" target="_blank" rel="noopener">Abrir el chat de Instagram</a>';
        otroCanal = '<a class="wz-salida" href="' + esc(waUrl) + '" target="_blank" rel="noopener">💬 Escribirnos por WhatsApp</a>';
        texto += ' Te copiamos el resumen por si quieres pegarlo en el chat.';
        aCopiar = msg;
      } else {
        boton = '<a class="wz-btn wa wz-crece" href="' + esc(waUrl) + '" target="_blank" rel="noopener">Seguir por WhatsApp</a>';
        otroCanal = '<a class="wz-salida" href="' + esc(igUrl) + '" target="_blank" rel="noopener">📷 Escribirnos por Instagram</a>';
      }

      /* Esta pantalla NO se va sola ni se reinicia. Antes el envío nativo de
         Shopify recargaba la página a los pocos segundos y el cotizador volvía
         al inicio, así que la persona alcanzaba a leer a medias y perdía el
         botón de su canal. Ahora se queda hasta que decida a dónde ir. */
      vista.innerHTML =
        '<div class="wz-pantalla"><div class="wz-ok">' +
          '<div class="wz-ok__ico">' + ico + '</div>' +
          '<h3>' + titulo + '</h3>' +
          '<p>' + texto + '</p>' +
          '<div class="wz-nav">' + boton + '</div>' +
          '<div class="wz-salidas">' +
            otroCanal +
            '<a class="wz-salida" href="' + esc(cfg.catalogo || '/collections/all') + '">🛍️ Ver el catálogo</a>' +
            '<button type="button" class="wz-salida" data-wz-denuevo>↺ Cotizar otra cosa</button>' +
          '</div>' +
        '</div></div>';

      var deNuevo = vista.querySelector('[data-wz-denuevo]');
      if (deNuevo) {
        deNuevo.addEventListener('click', function () {
          /* Recarga limpia, sin el contact_posted de Shopify colgando en la
             URL: es la forma más segura de dejar el cotizador como recién
             abierto sin ir tocando cada variable de estado a mano. */
          try { sessionStorage.removeItem(LLAVE_ENVIO); } catch (e) {}
          location.href = location.pathname;
        });
      }
      cajaP.hidden = true;
      btnAtras.hidden = true;
      cuenta.textContent = '';
      barraFill.style.width = '100%';
      if (aCopiar) copiar(aCopiar);   /* con la pantalla ya puesta */
    }

    /* Vuelta del envío nativo: Shopify recarga la página con contact_posted=true.
       El resumen quedó guardado antes de enviar para poder armar el botón de
       WhatsApp con todo escrito. */
    var vuelta = null;
    try { vuelta = JSON.parse(sessionStorage.getItem(LLAVE_ENVIO) || 'null'); } catch (e) {}
    if (vuelta) {
      /* La pantalla de éxito se restaura con el contact_posted que devuelve
         Shopify, y TAMBIÉN si el envío salió hace menos de dos minutos aunque
         la URL no traiga el parámetro. Ese era el caso que dejaba el cotizador
         reiniciado a los pocos segundos de enviar: la recarga llegaba sin
         contact_posted, el resumen se borraba igual y se perdía el éxito. */
      var reciente = vuelta.ts && (Date.now() - vuelta.ts) < 120000;
      try { sessionStorage.removeItem(LLAVE_ENVIO); } catch (e) {}
      if (/contact_posted=true/.test(location.search) || reciente) {
        preset = preset || 'otro';
        exito(true, vuelta);
        return;
      }
    }

    try { history.replaceState({ wz: 0 }, ''); } catch (e) {}
    pintar('der');
  }

  function init() {
    document.querySelectorAll('[data-wz]').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Cada vez que se cambia un ajuste en el editor de Shopify, la sección se
     vuelve a renderizar entera y el HTML nuevo llega sin nada enganchado: sin
     esto el asistente queda en blanco y el botón de enviar hace submit normal
     (recargando la página) en vez de pasar por el fetch. */
  document.addEventListener('shopify:section:load', function (e) {
    var raiz = e.target && e.target.querySelector ? e.target.querySelector('[data-wz]') : null;
    if (raiz) montar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
